import { GlobalAppState } from '@state/store';

export const getPaymentError = (state: GlobalAppState) => state.app.paymentError;
